const state = {
    now: Math.floor(Date.now() / 1000),
    started: false,
};

const getters = {}

const actions = {
    start({ commit }) {
        // Don't start multiple intervals
        if (state.started) {
            return
        }
        state.started = setInterval(() => {
            commit("tick");
        }, 1000);
    }
};

const mutations = {
    tick(state) {
        state.now = Math.floor(Date.now() / 1000);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}